import { Path } from '../types/path';
import { getPathProperty } from '../utils/getPathProperty';

export const uniqBy = <T extends Record<PropertyKey, any>>(array: Array<T>, path: Path<T>): Array<T> => {
   const set = new Set<unknown>();
   return array.reduce((result, nextValue) => {
      const key = getPathProperty(nextValue, path);
      if (set.has(key)) {
         return result;
      }

      set.add(key);
      result.push(nextValue);

      return result;
   }, [] as T[]);
};
